<template>
    <section>
        <div class="spacing vertical-center center">
            <div>

                <h2>Architectural evolution</h2>
                <p>To comply with 3GPP standards, 5G voice must use the same IMS-based architecture that provides VoLTE. Vo5G and VoLTE are simply different ways to access the same IMS-based voice services.</p>

            </div>
        </div>
        <div class="spacing-small center gray">

            <img src="~@/assets/images/chapter-3/architectural-evolution-1.png" alt="">

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    .vertical-center {
        display: flex;
        align-items: center;
    }

</style>